import IndicatorScreen from 'components/indicator/IndicatorScreen';
import { useParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import WsModalCreateContent from 'pages/ws/components/modalCreateContent/WsModalCreateContent';
import WsContentSearchEmpty from './components/WsContentSearchEmpty';
import WsContentSearchTable from './components/WsContentSearchTable';
import { useWsContentSearch } from './hooks/useWsContentSearch';

import type { JSX } from 'react';

/**
 * コンテンツ画面
 */
export default function WsContentSearch(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { pageNo } = useParams<{ pageNo?: string }>();

  const [acctState] = useAtom(AcctState);

  const {
    initialized,
    processing,
    pageNoState,
    contents,
    hasNext,
    modalCreateContentOpen,
    setModalCreateContentOpen,
    onPrev,
    onNext,
    onEdit,
    onReport,
    onCopy,
    onModalCreateContentOpen,
  } = useWsContentSearch(pageNo, acctState);

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {/* コンテンツ未登録の場合の表示 */}
      {(acctState.activeContent == null || acctState.activeContent.contentCount == 0) && (
        <WsContentSearchEmpty />
      )}

      {/* コンテンツ登録がある場合の表示 */}
      {acctState.activeContent?.contentCount > 0 && (
        <>
          {/* ローディング中の表示 */}
          <IndicatorScreen visible={processing} />

          <section className="section-header">
            <div className="container">
              <div className="d-md-flex d-flex-header">
                <div className="flex-shrink-0 flex-left">
                  <h2 className="flex-title">コンテンツ</h2>
                </div>
                <div className="flex-grow-1 flex-right">
                  <ul className="list-inline list-btn mb-0">
                    <li className="list-inline-item">
                      <a
                        onClick={onModalCreateContentOpen}
                        className="btn btn-common btn-common-w238 outline-blue"
                      >
                        + 新しいコンテンツを作成する
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {initialized && contents.length > 0 && (
            <WsContentSearchTable
              contents={contents}
              pageNo={pageNoState}
              hasNext={hasNext}
              onEdit={onEdit}
              onReport={onReport}
              onCopy={onCopy}
              onPrev={onPrev}
              onNext={onNext}
            />
          )}
        </>
      )}

      {/* コンテンツ作成モーダル */}
      <WsModalCreateContent open={modalCreateContentOpen} setOpen={setModalCreateContentOpen} />
    </>
  );
}
